import {defineStore} from "pinia";
import {computed, ref} from "vue";
import {GetLocalStorage, SetLocalStorage} from "lct-lib";
import {ICart} from "../../core/interface/ICart";
import {calcDiscount} from "../../core/promo/list";


const useCartStore = defineStore("cart", ()=>{
    const cart:any = ref<ICart>({
        items: [],
        ship_cost: "0.00",
        bill: {
            country: "United States"
        },
        ship: {
            country: "United States"
        },
        production_cost: "0.00",
        promo_code: "", // bỏ
        promo: {},
        discount: "0.00",
    });
    const isLoaded = ref(false);

    const load = async () => {
        isLoaded.value = false;
        const result:any = GetLocalStorage("cart");
        if(result) {
            cart.value.items = result;
        }
        else {
            cart.value.items = [];
        }
        //Promo
        const promo = GetLocalStorage("promo");
        if(promo) {
            cart.value.promo = promo;
        }
        isLoaded.value = true;

    }
    const removeItem = (at: number)=>{
        cart.value.items.splice(at,1);
        SetLocalStorage("cart", cart.value.items);
    }
    const addItem = (item: any)=>{
        cart.value.items.push(item);
        SetLocalStorage("cart", cart.value.items);
    }

    /**
     * Save to local storage
     */
    const saveItemInCart = ()=>{
        SetLocalStorage("cart", cart.value.items);
    }

    const emptyCart = ()=>{
        cart.value.items = [];
        SetLocalStorage("cart", cart.value.items);
        cart.value.promo_code = "";
        setPromo("");
    }

    /**
     * Promotion
     */

    const applyPromoByCode = async (code: string) => {
        try {
            if (!code || !code.trim()) {
                setPromo("")
                return null
            }
            const res = await fetch('https://sv.lct.vn/tbs/promo/get', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code: code.trim() })
            })
            const promo = await res.json().catch(() => ({})) as any

            if (promo && promo.active) {
                // accept the promo
                setPromo(promo);
                return promo
            } else {
                // invalid or inactive promo -> clear
                setPromo("");
                return null
            }
        } catch (e) {
            console.log(e)
            return null
        }
    }
    // const setPromoCode = (code: string)=>{
    //     cart.value.promo_code = code;
    //     SetLocalStorage("cart-promo", code);
    // }
    const setPromo = (promo: any)=>{
        cart.value.promo = promo;
        SetLocalStorage("promo", promo);
    }




    const discount = computed(()=>{
        if (!cart.value) return 0
        const promo: any = cart.value.promo
        const sub = Number(cart.value?.subtotal ?? 0)

        let d = 0
        if (promo && promo.active !== false && Number.isFinite(Number(promo.value))) {
            const val = Number(promo.value)
            if (promo.type === 'percent') {
                d = sub * (val / 100)
            } else if (promo.type === 'fixed') {
                d = val
            }
        }
        // Clamp: discount không vượt quá subtotal
        if (d > sub) d = sub

        cart.value.discount = d.toFixed(2)
        return cart.value.discount
    })

    const subtotal = computed(()=>{
        let sum = 0;
        if(!cart.value) return 0;

        for (const item of cart.value.items) {
            sum += Number(item.sale_price) * Number(item.qty);
            if(item.option && item.option.price) {
                sum += Number(item.option.price);
            }
        }
        cart.value.subtotal = sum.toFixed(2);
        return cart.value.subtotal;
    })
    const tax = computed(()=>{
        if(!cart.value) return 0;
        cart.value.tax = (Number(subtotal.value) * (7.25 / 100)).toFixed(2);
        return cart.value.tax;
    })

    const shipCost = computed(()=>{
        if(cart.value && cart.value.ship_method) {
            cart.value.ship_cost = cart.value.ship_method.value.toFixed(2);
            return cart.value.ship_cost;
        } else {
            return 0;
        }
    })

    const productionCost = computed(()=>{
        if(!cart.value || !cart.value.production_speed) return 0;
        cart.value.production_cost = cart.value.production_speed.priceDelta.toFixed(2);
        return cart.value.production_cost;
    })

    const total = computed(()=>{
        let sum =  Number(subtotal.value) + Number(tax.value) + Number(shipCost.value) + Number(productionCost.value) - Number(discount.value);
        cart.value.total = sum.toFixed(2);
        return cart.value.total;
    })

    /**
     * Validate cart
     */
    const isValid = computed(()=>{
        if (
            cart.value.bill.firstname && cart.value.bill.firstname.trim() !== '' &&
            cart.value.bill.lastname && cart.value.bill.lastname.trim() !== '' &&
            cart.value.bill.address && cart.value.bill.address.trim() !== '' &&
            cart.value.bill.city && cart.value.bill.city.trim() !== '' &&
            cart.value.bill.state && cart.value.bill.state.trim() !== '' &&
            cart.value.bill.postal_code && cart.value.bill.postal_code.trim() !== '' &&
            cart.value.bill.country && cart.value.bill.country.trim() !== '' &&
            cart.value.bill.phone && cart.value.bill.phone.trim() !== '' &&
            cart.value.bill.email && cart.value.bill.email.trim() !== '' &&

            cart.value.ship.firstname && cart.value.ship.firstname.trim() !== '' &&
            cart.value.ship.lastname && cart.value.ship.lastname.trim() !== '' &&
            cart.value.ship.address && cart.value.ship.address.trim() !== '' &&
            cart.value.ship.city && cart.value.ship.city.trim() !== '' &&
            cart.value.ship.state && cart.value.ship.state.trim() !== '' &&
            cart.value.ship.postal_code && cart.value.ship.postal_code.trim() !== '' &&
            cart.value.ship.country && cart.value.ship.country.trim() !== '' &&
            cart.value.ship.phone && cart.value.ship.phone.trim() !== '' &&
            cart.value.ship.email && cart.value.ship.email.trim() !== '' &&

            cart.value.ship_method && cart.value.ship_method.label !== "" &&
            cart.value.email && cart.value.email.trim() !== ''
        ) {
            return true
        } else
        return false
    })


    return {cart, isLoaded, load, subtotal, tax, total, removeItem, shipCost, saveItemInCart, isValid, addItem, productionCost, discount, emptyCart, applyPromoByCode, setPromo}
})

export {useCartStore}
